import React, { useState } from 'react';
import { ZoomIn } from 'lucide-react';
const images = [{
  url: 'https://www.6gtools.com/uploaded/images/products/TV42SR-1.webp',
  alt: 'Titan VI-Pro End Mill'
}, {
  url: 'https://www.6gtools.com/uploaded/images/Redesign/Reference%20Images/Titan-VIPro-Dims.webp',
  alt: 'Technical Dimensions'
}];
export function ProductGallery() {
  const [activeIndex, setActiveIndex] = useState(0);
  return <div className="flex flex-col gap-4 max-w-md" data-id="element-92">
      {/* Main Image */}
      <div className="relative h-64 md:h-72 bg-white border border-gray-200 rounded-lg overflow-hidden group cursor-zoom-in flex items-center justify-center p-4" data-id="element-93">
        <img src={images[activeIndex].url} alt={images[activeIndex].alt} className="max-w-full max-h-full object-contain" data-id="element-94" />
        <div className="absolute bottom-4 right-4 bg-white/90 px-3 py-1.5 rounded-full shadow-sm border border-gray-100 flex items-center gap-2 text-xs font-medium text-gray-600 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-95">
          <ZoomIn className="w-3.5 h-3.5" data-id="element-96" />
          Click to enlarge
        </div>
      </div>

      {/* Thumbnails */}
      <div className="flex gap-4" data-id="element-97">
        {images.map((img, idx) => <button key={idx} onClick={() => setActiveIndex(idx)} className={`relative w-20 h-20 bg-white border-2 rounded-md overflow-hidden p-1 transition-colors ${activeIndex === idx ? 'border-brand-darkGold' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-98">
            <img src={img.url} alt={`Thumbnail ${idx + 1}`} className="w-full h-full object-contain" data-id="element-99" />
          </button>)}
      </div>
    </div>;
}